<template>
  <div>
    <template v-if="$route.name !== 'login'">
      <cash-hero-navbar :bright="true" />
    </template>
    <router-view />
  </div>
</template>

<script>
import CashHeroNavbar from '../partials/CashHeroNavbar'

export default {
  name: 'Primary',
  components: { CashHeroNavbar },
  mounted () {
    (function ($) {
      'use strict'
      const navbarCollapse = function () {
        if ($('#mainNav').offset().top > 72) {
          $('#mainNav').addClass('navbar-scrolled')
        } else {
          $('#mainNav').removeClass('navbar-scrolled')
        }
      }
      navbarCollapse()
      $(window).scroll(navbarCollapse)
    })(jQuery)
  }
}
</script>

<style scoped>

</style>
